// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_25WsVuzgeFwx","title":"_12DV2qE2Dm_M","content":"_37AhtDpz916f","inner":"_2Q52cW2dLsg8","icon":"BYyi6aDfhNh9","link":"_1heyWgFFX8dD"};